import { useContext } from "react";
import TemplateDesignerContext from "./TemplateDesignerContext";

const useTemplateDesigner = () => {
    return useContext(TemplateDesignerContext);
}

export default useTemplateDesigner;